module.exports = __webpack_public_path__ + "static/media/activity_reactions.a8343ced.svg";